import { HandoverSection } from "../molecules/HandoverSection";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { ChevronRightIcon, Icon } from "ui/gluestack/icon";
import { CellListColumnModel, CellsList } from "../molecules/CellsList";
import { NoItemsComponent } from "ui/atoms/noItems";
import { CalendarEventModal } from "app/features/calendar/modals/CalendarEventModal";
import { ShiftHandoverTaskClass } from "../../../services/api/types/shiftHandover/classes/ShiftHandoverTaskClass";
import { useHandleShiftHandoverAppointments } from "../hooks/useHandleShiftHandoverAppointments";

interface Props {
  data: ShiftHandoverTaskClass[];
  isEditing?: boolean;
}

export function DueToday({ data, isEditing }: Props) {
  const { ref, handleTaskRowPress } = useHandleShiftHandoverAppointments();

  const columns: CellListColumnModel<ShiftHandoverTaskClass>[] = [
    {
      title: "Appointment Type",
      key: "typeFriendly",
      renderData: (appointment) => (
        <Text className="font-semibold capitalize">
          {appointment.typeFriendly}
        </Text>
      ),
    },
    {
      title: "Description",
      key: "description",
    },
    {
      title: "Due Date/Time",
      key: "dueDateTime",
      renderData: (appointment) => {
        return (
          <View>
            <Text>{appointment.dueDateTime.time}</Text>
            <Text>{`(${appointment.dueDateTime.date})`}</Text>
          </View>
        );
      },
    },
    {
      title: "Preparation needed",
      key: "preparation_needed",
      renderData: (task) => {
        return <Text>{task.preparationNeeded ? "Yes" : "No"}</Text>;
      },
    },
    {
      title: "State",
      key: "state",
      renderData: (appointment) => {
        return (
          <View className="flex-row justify-between items-center">
            <Text
              className={`${appointment.state.color} font-semibold first-letter:uppercase`}
            >
              {appointment.state.value}
            </Text>
            {isEditing ? <Icon as={ChevronRightIcon} /> : null}
          </View>
        );
      },
    },
  ];

  return (
    <HandoverSection
      title="Upcoming Appointments"
      titleClassNames="text-success-800"
    >
      <>
        <CellsList
          data={data}
          columns={columns}
          onRowPress={isEditing ? handleTaskRowPress : undefined}
          cellBackgroundColor="bg-success-50/50"
          noDataMessage={
            <NoItemsComponent
              title="No Upcoming Appointments"
              subtitle="No appointments are due today"
            />
          }
        ></CellsList>
        <CalendarEventModal ref={ref} />
      </>
    </HandoverSection>
  );
}
